import { render, staticRenderFns } from "./ListFieldTagTypes.vue?vue&type=template&id=6f2e0df0"
import script from "./ListFieldTagTypes.vue?vue&type=script&lang=js"
export * from "./ListFieldTagTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports